import { Box, Typography } from "@mui/material";
import { colorPositive } from "../../../theme";

interface AnuncioImagensProps {
  imagens: string[];
}

export function AnuncioImagens({
  imagens,
}: AnuncioImagensProps) {
  const total = imagens.length;
  const visiveis = imagens.slice(0, imagens.length);
  const isCombo = total > 1;


  return (
    <Box position="relative">
      {/* GRID DE IMAGENS */}
      <Box
        sx={{
          width: "100%",
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
          gap: 0.5,
          bgcolor: "grey.100",
        }}
      >
        {visiveis.map((img, index) => {
  const isUltimaImpar =
    total % 2 !== 0 && index === visiveis.length - 1;

        return (
          <Box
            key={index}
            sx={{
              width: "100%",
              height: 200,
              borderRadius: 2,
              overflow: "hidden",
              gridColumn: isUltimaImpar ? "span 2" : undefined,
              bgcolor: "#f1f5f9",          // fallback elegante
            }}
          >
            <Box
              component="img"
              src={img}
              alt={`Imagem ${index + 1}`}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",        //  cover | contain
                transition: "transform .3s ease",
                "&:hover": {
                  transform: "scale(1.03)",
                },
              }}
            />
          </Box>
        );
      })}
      </Box>

      {/* TAG DO TIPO */}
      <Box
        sx={{
          position: "absolute",
          top: 12,
          left: 12,
          bgcolor: colorPositive,
          px: 1.5,
          py: 0.5,
          borderRadius: 1,
        }}
      >
        <Typography
          fontSize="0.7rem"
          fontWeight={800}
          fontStyle="italic"
          textTransform="uppercase"
          color="white"
        >
          Disponível
        </Typography>
      </Box>

      {/* BADGE (COMBO / ÚNICO) */}
      <Typography
        sx={{
          position: "absolute",
          top: 12,
          right: 12,
          bgcolor: "primary.main",
          color: "#fff",
          fontSize: "10px",
          fontWeight: 800,
          px: 2,
          py: 0.5,
          borderRadius: 99,
        }}
      >
        {isCombo ? `COMBO DE ${total}` : "ANÚNCIO ÚNICO"}
      </Typography>
    </Box>
  );
}
